import { useState, createContext } from "react";

export const loaderContext = createContext();

const LoaderProvider = (props) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <loaderContext.Provider value={{ isLoading, setIsLoading }}>
      {props.children}
    </loaderContext.Provider>
  );
};

export default LoaderProvider;
